import clsx from 'clsx';
import styles from './spinner.module.scss';

interface IWaitingSpinnerProps {
  className?: string;
}

export const Spinner = (props: IWaitingSpinnerProps) => {
  return (
    <div className={clsx('mx-auto h-15 w-15', props.className)}>
      <svg className={styles['waiting-spinner__icon']} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52'>
        <circle className={styles['waiting-spinner__circle-1']} cx='26' cy='26' r='25' fill='none' />
        <circle className={styles['waiting-spinner__circle-2']} cx='26' cy='26' r='18' fill='none' />
        <circle className={styles['waiting-spinner__circle-3']} cx='26' cy='26' r='11' fill='none' />
      </svg>
    </div>
  );
};
